import React from 'react';

/**
 * Floppy-disk save icon (Lucide-style).
 * Inherits color from the parent via `currentColor`.
 * Default size is 1em so it scales with the button text.
 */
export function SaveIcon({ size = '1em', className }: { size?: string | number; className?: string }) {
  return (
    <svg
      className={className ? `save-icon ${className}` : 'save-icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  );
}

export default SaveIcon;
